import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import BigSlides from './bigSlides';
import SideText from './sideText';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const Headline = ({ content }) => {
    const sideTextData = {
        sideTextData: content.sideTextData,
        title: content?.pageConfig?.headTitle1,
        mouldeSmallImage: content?.pageConfig?.mouldeSmallImage
    };

    return (
        <div className={styles.column}>
            <Chip
                id="285826"
                type="recommend"
                title="大幻灯"
                groupName="预防肿瘤"
                content={content.bigSildesData}
            >
                <BigSlides />
            </Chip>
            <Chip
                id="285827"
                type="recommend"
                title="头条"
                groupName="预防肿瘤"
                content={sideTextData}
            >
                <SideText />
           </Chip>
        </div>
    );
};

Headline.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Headline);
